<template>
  <el-dialog
    :title="goodsInfo.seckillGoodsId ? '编辑特惠商品' : '新增特惠商品'"
    :visible.sync="visible"
    width="550px"
    :close-on-press-escape="false"
    @closed="handleClosed">
    <el-form
      ref="ruleForm"
      v-loading="loading"
      :model="lotteryInfo"
      :disabled="!goodsInfo.goodsId"
      :rules="rules"
      label-width="110px">
      <el-form-item label="商品名称:">
        {{ goodsInfo.goodsName }}
      </el-form-item>
      <el-form-item label="库存量:">
        <span v-if="goodsInfo.storageCount">{{ goodsInfo.storageCount }}件</span>
      </el-form-item>
      <el-form-item label="原价:">
        <span v-if="goodsInfo.goodsId">{{ goodsInfo.goodsPayType === 1 ? goodsInfo.price + '元' : goodsInfo.points + '积分' }}</span>
      </el-form-item>
      <el-form-item
        label="特惠价格:"
        prop="seckillPrice">
        <el-input-number
          v-model="lotteryInfo.seckillPrice"
          :precision="precision"
          :min="min"
          :max="maxPrice"></el-input-number>
      </el-form-item>
      <el-form-item
        label="特惠库存:"
        prop="seckillStorageCount">
        <el-input-number
          v-model="lotteryInfo.seckillStorageCount"
          :precision="0"
          :min="1"
          :max="goodsInfo.storageCount"></el-input-number>
      </el-form-item>
      <el-form-item
        label="限购数量:"
        prop="seckillCountLimit">
        <el-input-number
          v-model="lotteryInfo.seckillCountLimit"
          :precision="0"
          :min="1"
          :max="lotteryInfo.seckillStorageCount"></el-input-number>
      </el-form-item>
      <el-form-item
        label="参与会员折扣:"
        prop="memberDiscount">
        <el-switch
          v-model="lotteryInfo.memberDiscount"
          active-color="#13ce66"
          inactive-color="#ff4949">
        </el-switch>
      </el-form-item>
      <el-form-item
        v-show="lotteryInfo.status === 1"
        label="抢购时间:"
        prop="time">
        <el-date-picker
          v-model="lotteryInfo.time"
          type="datetimerange"
          :picker-options="pickerOptions"
          placeholder="选择抢购时间">
        </el-date-picker>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-checkbox
        v-model="lotteryInfo.status"
        :disabled="!goodsInfo.goodsId"
        style="margin-right:10px"
        :true-label="1"
        :false-label="0">立即发布</el-checkbox>
      <el-button
        type="primary"
        @click="selectGoods">选择商品</el-button>
      <el-button
        :loading="loading"
        @click="toggleModal(false)">取 消</el-button>
      <el-button
        type="primary"
        :loading="loading"
        @click="handleSubmit">提 交</el-button>
    </span>
    <goods-select-modal
      ref="modal"
      :callback="formatSelected" />
  </el-dialog>
</template>

<script>
import GoodsSelectModal from './goods-select-modal.vue'
// import moment from 'moment'
import _ from 'lodash'
export default {
  name: 'LotteryRegisterModal',
  components: { GoodsSelectModal },
  props: {
    callback: Function
  },
  data() {
    return {
      loading: false,
      visible: false,
      pickerOptions: {
        disabledDate: () => {
          return false
          // return date < Date.now()
        }
      },
      goodsInfo: {},
      lotteryInfo: {
        seckillPrice: undefined,
        seckillStorageCount: 1,
        seckillCountLimit: 1,
        memberDiscount: true,
        time: null,
        seckillType: 1,
        status: 0,
        sellCount: 0
      }
    }
  },
  computed: {
    precision() {
      return this.goodsInfo.goodsPayType === 1 ? 2 : 0
    },
    min() {
      return this.goodsInfo.goodsPayType === 1 ? 0.01 : 1
    },
    maxPrice() {
      return this.goodsInfo.goodsPayType === 1 ? this.goodsInfo.price - 0.01 : this.goodsInfo.points - 1
    },
    rules() {
      return {
        seckillPrice: [
          { required: true, message: '请输入特惠价格', trigger: 'blur' }
        ],
        seckillStorageCount: [
          { required: true, message: '请输入特惠库存', trigger: 'blur' }
        ],
        seckillCountLimit: [
          { required: true, message: '请输入限购数量', trigger: 'blur' }
        ],
        time: [
          { required: this.lotteryInfo.status === 1, message: '请选择特惠时间', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    toggleModal(visible) {
      this.visible = visible
    },
    handleClosed() {
      this.lotteryInfo = {
        seckillPrice: undefined,
        seckillStorageCount: 1,
        seckillCountLimit: 1,
        memberDiscount: true,
        time: null,
        seckillType: 1,
        status: 0,
        sellCount: 0
      }
      this.$refs.ruleForm.clearValidate()
    },
    handleCountChange(val) {
      console.log(val)
    },
    handleSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          let lotteryInfo = _.cloneDeep(this.lotteryInfo)
          lotteryInfo = {
            ...lotteryInfo,
            startTime: lotteryInfo.time ? +lotteryInfo.time[0] : null,
            closeTime: lotteryInfo.time ? +lotteryInfo.time[1] : null,
            memberDiscount: +lotteryInfo.memberDiscount
          }
          console.log(lotteryInfo)
          delete lotteryInfo.time
          this.loading = true
          const dispatch = this.goodsInfo.seckillGoodsId ? 'updateseckillgoods' : 'addseckillgoods'
          this.$store.dispatch(`discount/${dispatch}`, {
            payload: {
              vendorId: this.goodsInfo.vendorId,
              goodsId: this.goodsInfo.goodsId,
              seckillGoodsId: this.goodsInfo.seckillGoodsId || null,
              ...lotteryInfo
            },
            success: () => {
              this.loading = false
              this.callback && this.callback()
              this.toggleModal(false)
            },
            fail: () => {
              this.loading = false
            }
          })
        }
      })
    },
    formatSelected(data) {
      data = _.cloneDeep(data)
      data.goodsId = data.exchangeGoodsId
      this.lotteryInfo.seckillPrice = data.goodsPayType === 1 ? 0.01 : 1
      this.goodsInfo = data
    },
    selectGoods() {
      this.$refs.modal.fetch()
    },
    fetch({ vendorId, seckillGoodsId }) {
      if (seckillGoodsId) {
        this.loading = true
        this.$store.dispatch('discount/getseckillgoods', {
          payload: {
            vendorId, seckillGoodsId
          },
          success: res => {
            this.loading = false
            this.goodsInfo = res.data
            this.lotteryInfo = {
              ...this.lotteryInfo,
              seckillPrice: res.data.seckillPrice,
              seckillStorageCount: res.data.seckillStorageCount,
              seckillCountLimit: res.data.seckillCountLimit,
              memberDiscount: res.data.memberDiscount === 1,
              time: res.data.createdTime ? [res.data.createdTime, res.data.closeTime] : null,
              seckillType: res.data.seckillPrice,
              status: res.data.status,
              sellCount: res.data.sellCount
            }
            this.toggleModal(true)
          },
          fail: () => {
            this.loading = false
          }
        })
      } else {
        this.toggleModal(true)
      }
    }
  }
}
</script>
<style lang="stylus" scoped>
.search-form {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
}
</style>
